// Chaos card game data with rankings (eclectic mix)
export const CHAOS_CARDS = [
  { id: 1, name: "Orcas",
    image: "/images/chaos/chaos_1.jpg", rank: 1 },
  { id: 2, name: "Snacks",
    image: "/images/chaos/chaos_2.jpg", rank: 2 },
  { id: 3, name: "Shaq",
    image: "/images/chaos/chaos_3.jpg", rank: 3 },
  { id: 4, name: "Cats",
    image: "/images/chaos/chaos_4.jpg", rank: 4 },
  { id: 5, name: "Dogs",
    image: "/images/chaos/chaos_5.jpg", rank: 5 },
  { id: 6, name: "Friends",
    image: "/images/chaos/chaos_6.jpg", rank: 6 },
  { id: 7, name: "Stims",
    image: "/images/chaos/chaos_7.jpg", rank: 7 },
  { id: 8, name: "Songs",
    image: "/images/chaos/chaos_8.jpg", rank: 8 },
  { id: 9, name: "Cheeses",
    image: "/images/chaos/chaos_9.jpg", rank: 9 },
  { id: 10, name: "Fashion",
    image: "/images/chaos/chaos_10.jpg", rank: 10 },
  { id: 11, name: "Books",
    image: "/images/chaos/chaos_11.jpg", rank: 11 },
  { id: 12, name: "Karaoke",
    image: "/images/chaos/chaos_12.jpg", rank: 12 },
  { id: 13, name: "Dan Marino",
    image: "/images/chaos/chaos_13.jpg", rank: 13 },
  { id: 14, name: "Swimming",
    image: "/images/chaos/chaos_14.jpg", rank: 14 },
  { id: 15, name: "Snow Days",
    image: "/images/chaos/chaos_15.jpg", rank: 15 },
  { id: 16, name: "Movies",
    image: "/images/chaos/chaos_16.jpg", rank: 16 },
  { id: 17, name: "Cars",
    image: "/images/chaos/chaos_17.jpg", rank: 17 },
  { id: 18, name: "Candles",
    image: "/images/chaos/chaos_18.jpg", rank: 18 },
  { id: 19, name: "Games",
    image: "/images/chaos/chaos_19.jpg", rank: 19 },
  { id: 20, name: "Cheese Sticks",
    image: "/images/chaos/chaos_20.jpg", rank: 20 },
  { id: 21, name: "Laundry",
    image: "/images/chaos/chaos_21.jpg", rank: 21 },
  { id: 22, name: "Blizzards",
    image: "/images/chaos/chaos_22.jpg", rank: 22 },
  { id: 23, name: "Batteries",
    image: "/images/chaos/chaos_23.jpg", rank: 23 },
  { id: 24, name: "Ties",
    image: "/images/chaos/chaos_24.jpg", rank: 24 },
  { id: 25, name: "Tripping",
    image: "/images/chaos/chaos_25.jpg", rank: 25 },
  { id: 26, name: "Doom Scrolling",
    image: "/images/chaos/chaos_26.jpg", rank: 26 },
  { id: 27, name: "Eye Rolling",
    image: "/images/chaos/chaos_27.jpg", rank: 27 },
  { id: 28, name: "Medical Debt",
    image: "/images/chaos/chaos_28.jpg", rank: 28 },
  { id: 29, name: "Cough",
    image: "/images/chaos/chaos_29.jpg", rank: 29 },
  { id: 30, name: "Biting Tongue",
    image: "/images/chaos/chaos_30.jpg", rank: 30 }
];